<div *ngIf="statusCheck == 'employeeSearch'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">Employee Search</p>
            <mat-form-field class="mat-height40 mat-input-style pl-10">
              <mat-icon matPrefix>search</mat-icon>
              <input matInput type="search" placeholder="Search" [(ngModel)]="searchEmployee" (input)="onEmployeeSearch(searchEmployee)" />
            </mat-form-field>
          </div>
          <div class="popup-close">
            <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <div class="table-container mt-20">
          <table class="table">
            <thead>
              <tr>
                <th>Employee_Name</th>
                <th>Employee_Code</th>
                <th>Date_Of_Joining</th>
                <th>Official_Email</th>
                <th>Reporting Manager Name</th>
                <th>Designation</th>
                <th>Department</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of getEmployeeSearchData">
                <td>{{data.firstName}} {{data.lastName}}</td>
                <td>{{data.empCode}}</td>
                <td>{{data.dateOfJoining | date: 'dd-MM-yyyy'}}</td>
                <td>{{data.email}}</td>
                <td>{{data.reportingManagerName}}</td>
                <td>{{data.designation}}</td>
                <td>{{data.department}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ion-col>
    </ion-row>
  </div>
</div>

<div *ngIf="statusCheck == 'helpDesk' &&checkClickOnDIY!=='DIY' ">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="header-row phi-flex-center phi-justify-content-between phi-gap-12 w-100">
          <h3 class="popup-heading ml-15">What Do You Want to View?</h3>
          <!-- <p class="fs-16 fs_14ForMobile font_regular fs_14ForMobileView">What Do You Want to View?</p> -->

          <button *ngIf="!isShowUploadUserManual" mat-icon-button mat-dialog-close class="close-btn">
            <ion-icon name="close-outline"></ion-icon>
          </button>

          <div class="popup-close" *ngIf="isShowUploadUserManual">
            <span class="ml-35 mr-5 fs-30 material-icons popup-close-icon" (click)="closeother()">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="mt-20">
      <!-- <ion-col size="12" size-md="4" *ngIf="!isShowUploadUserManual">
        <div class="helpDeskcardBox">
          <div>
            <div><img src="././assets/icon/TicketingIcon.svg" alt=""></div>
            <div><button type="button" (click)="onClickOpenTickets()">Ticketing</button></div>
          </div>
        </div>
      </ion-col> -->

      <ion-col size="12" size-md="6" *ngIf="!isShowUploadUserManual">
        <div class="helpDeskcardBox">
          <div>
            <div><img src="././assets/icon/userManualIcon.svg" alt="" /></div>
            <div style="gap: 10px;">
              <button type="button" class="w-100" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'" (click)="onClickShowUploadUserManual()">Upload Manual</button>

              <button type="button" class="w-100" *ngIf="!(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin')" (click)="onClickShowUploadUserManual()">View Manual</button>
              <!-- <button type="button"  class="w-100" (click)="downloadUserManual()">Download Manual</button> -->
            </div>
          </div>
        </div>
      </ion-col>

      <ion-col size-sm="12" size-md="6" *ngIf="!isShowUploadUserManual">
        <div class="helpDeskcardBox">
          <!------------------------------- need to uncomment for video---------------------------------- -->
          <div>
            <div><img src="././assets/icon/VideosIcon.svg" alt="" /></div>
            <div><button type="button" (click)="addVideo()">DIY Videos</button></div>
          </div>
          <!-- <div>
            <div><img src="././assets/icon/VideosIcon.svg" alt=""></div>
            <div><button type="button">DIY Videos</button></div>
          </div> -->
        </div>
      </ion-col>
    </ion-row>
    <!-------------------------------------------------------------------------------------- -->

    <!-- ------------------------------------------------------------------------------------------ -->

    <div *ngIf="isShowUploadUserManual && checkClickOnDIY!=='DIY'">
      <ion-row>
        <ion-col size="12">
          <div class="cardBox">
            <div class="attached-files-container">
              <div class="file-card">
                <div *ngFor="let data of helpDeskFileData; let i = index" class="file-row">
                  <div class="file-info">
                    <img class="w-40 mr-20" src="././assets/icon/PDFfileIcon.svg" alt="" />
                    <a class="fileName">{{ data.userManualFileName }}</a>
                  </div>
                  <div class="file-actions-icon">
                    <button mat-icon-button (click)="viewHandBookFile(data.userManualUrl, data.userManualFileName)">
                      <span class="material-icons viewIcon">visibility</span>
                    </button>
                    <button mat-icon-button (click)="downloadHandBookFile(data.userManualUrl, data.userManualFileName)" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                      <span class="material-icons">download</span>
                    </button>
                    <button mat-icon-button (click)="onClickDeleteHelpDesk(data.id)" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                      <span class="material-icons">close</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
          <div class="cardBox mt-10">
            <div *ngIf="!showBrowseBtn" class="upload-box display-center mt-5 cp" (click)="browseImage.click()">
              <div class="upload-file-container">
                <input #browseImage type="file" (change)="onFileSelected($event)" style="display:none;" />
                <div class="cp text-center font_regular mr-15">
                  <span class="material-icons fs-18 fs_16ForMobile">upload_file</span>
                  <div class="fs-12 text_blue"><u>User Manual upload</u></div>
                </div>
              </div>
            </div>
            <div *ngIf="showBrowseBtn" class="w-100 upload-file-container display-center mt-20 cp">
              <div class="d-flex mb-20 mt-20">
                <div class="verticle-center mr-20">
                  <img src="././assets/icon/successImport.svg" />
                </div>
                <div class="flex-column">
                  <label class="fs-14 fs_12ForMobile font_medium text_gray1 mb-10">File Uploaded Successfully.</label>
                  <div class="d-flex">
                    <label class="fs-12 blue font_medium cl-black mx-width">{{fileName}}</label>
                    <span class="material-icons fs-12" (click)="onCloseFile()">close</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="upload-file-validation">
              <p>file format</p>
              <button (click)="onClickSaveUserManualFile()" [disabled]="isDisabledUploadPolicyBtn" [ngStyle]="{opacity:isDisabledUploadPolicyBtn?0:1}">Save</button>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>

<div *ngIf="statusCheck == 'hrHandBook'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 fs_14ForMobile font_regular">HR HandBook</p>
          </div>
          <div class="popup-close">
            <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
      <ion-col size="12">
        <div>
          <mat-form-field class="mat-height40 mat-input-style pl-10">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchEmployee" (input)="onHandbookFileSearch(searchEmployee)" />
          </mat-form-field>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <div><p class="fs-14 fs_12ForMobile font_semibold">Attached Files</p></div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <div class="cardBox">
          <div class="attached-files-container">
            <div class="file-card">
              <div *ngFor="let data of handbookFileData; let i = index" class="file-row">
                <div class="file-info">
                  <img class="w-40 mr-20" src="././assets/icon/PDFfileIcon.svg" alt="" />
                  <a class="fileName">{{ data.handbookFileName }}</a>
                </div>
                <div class="file-actions-icon">
                  <button mat-icon-button (click)="viewHandBookFile(data.handbookUrl, data.handbookFileName)">
                    <span class="material-icons viewIcon">visibility</span>
                  </button>
                  <button mat-icon-button (click)="downloadHandBookFile(data.handbookUrl, data.handbookFileName)">
                    <span class="material-icons">download</span>
                  </button>
                  <button mat-icon-button (click)="onClickDeleteHandbookFile(data.id)" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                    <span class="material-icons">close</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
        <div class="cardBox mt-10" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
          <div *ngIf="!showBrowseBtn" class="upload-box display-center mt-5 cp" (click)="browseImage.click()">
            <div class="upload-file-container">
              <input #browseImage type="file" (change)="onFileSelected($event)" style="display:none;" />
              <div class="cp text-center font_regular mr-15">
                <span class="material-icons fs-18 fs_16ForMobile">upload_file</span>
                <div class="fs-12 text_blue"><u>HR Handbook upload</u></div>
              </div>
            </div>
          </div>
          <div *ngIf="showBrowseBtn" class="w-100 upload-file-container display-center mt-20 cp">
            <div class="d-flex mb-20 mt-20">
              <div class="verticle-center mr-20">
                <img src="././assets/icon/successImport.svg" />
              </div>
              <div class="flex-column">
                <label class="fs-14 fs_12ForMobile font_medium text_gray1 mb-10">File Uploaded Successfully.</label>
                <div class="d-flex">
                  <label class="fs-12 blue font_medium cl-black mx-width">{{fileName}}</label>
                  <span class="material-icons fs-12" (click)="onCloseFile()">close</span>
                </div>
              </div>
            </div>
          </div>
          <div class="upload-file-validation">
            <p>supported file format - png/jpeg/jpg/xlsx/pdf.</p>
            <button (click)="onClickSaveHrHandbookFile()" [disabled]="isDisabledUploadPolicyBtn">Save</button>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </div>
</div>
